import { handleResponseOld, makeGet } from './helpers';

type fetchDiscoverPageSuggestionsBySearchTermParams = {
    authToken: string;
    deployment: string;
    searchTerm: string;
};

type fetchDiscoverPageSuggestionsBySearchTermResponse = {
    error: boolean;
    payload: [
        {
            imageURL: string;
            title: string;
        }
    ];
};

/**
 * Fetches related searched from discover page title table, based on current item (search term)
 * @function fetchSuggestionsBySearchTerm
 * @category SEARCH API
 * @param {fetchDiscoverPageSuggestionsBySearchTermParams}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/search/getsuggestiondiscoverpages?searchTerm={}
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/p8swwvetjb/resources/xi40gl/methods/GET
 */
export const fetchSuggestionsBySearchTerm = ({
    authToken,
    deployment,
    searchTerm,
}: fetchDiscoverPageSuggestionsBySearchTermParams) =>
    new Promise<fetchDiscoverPageSuggestionsBySearchTermResponse>((resolve, reject) => {
        const request = makeGet({ authToken, deployment, path: '<SEARCH-API>getsuggestiondiscoverpages' });
        request.query({ searchTerm });
        request.end((err, response) => {
            handleResponseOld({ err, reject, resolve, response });
        });
    });
